const UiMessagePropsOption = {
  message: { type: String, required: true },
  type: { type: String, default: "info" },
  icon: { type: String },
  delay: { type: Number, default: 3e3 },
  offset: { type: Number, default: 20 }
};

export { UiMessagePropsOption };
//# sourceMappingURL=message.mjs.map
